import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/logo/inanc_tur_yeni_logo.webp")